module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"save_button.label":"Salvar"},"en":{"save_button.label":"Save"}}')
  delete Component.options._Ctor
}
